import React from "react";
import Todo from "./component/Todo";  

const App = () => {
  return (
    <>
     <Todo/>
    </>
  );
};

export default App;
